export class Utility {
  static deepCopy(obj: any): any {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    const copy: any = Array.isArray(obj) ? [] : {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (obj[key] instanceof Date) {
          copy[key] = new Date(obj[key]);
        } else {
          copy[key] = Utility.deepCopy(obj[key]);
        }
      }
    }
    return copy;
  }

  static isMobileScreen = window.innerWidth < 992
  static isTabletOrMobileScreen = window.innerWidth <= 1280
  static isTabletScreen = window.innerWidth <= 1280 && window.innerWidth >= 992

  static percentage(value: number, total: number): number {
    if (total === 0) return 0
    return (value / total) * 100
  }

  static randomInt(from: number, to: number) {
    return Math.floor(Math.random() * (to - from) + from)
  }

  static toFloat(value: number, fractionalDigits: number = 2): number {
    return parseFloat(value.toFixed(fractionalDigits))
  }

  static invertHex(hex: string) {
    return '#'+(Number(`0x1${hex}`) ^ 0xFFFFFF).toString(16).substr(1).toUpperCase()
  }

  static invertColor(hex: string, bw: boolean) {
    if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error('Invalid HEX color.');
    }
    let r = parseInt(hex.slice(0, 2), 16),
      g = parseInt(hex.slice(2, 4), 16),
      b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
      // https://stackoverflow.com/a/3943023/112731
      return (r * 0.299 + g * 0.587 + b * 0.114) > 186
        ? '#000000'
        : '#FFFFFF';
    }
    // invert color components
    let rStr = (255 - r).toString(16),
    gStr = (255 - g).toString(16),
    bStr = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + Utility.padZero(rStr) + Utility.padZero(gStr) + Utility.padZero(bStr);
  }
  // static invertColor(hex: string) {
  //   if (hex.indexOf('#') === 0) {
  //     hex = hex.slice(1);
  //   }
  //   // convert 3-digit hex to 6-digits.
  //   if (hex.length === 3) {
  //     hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  //   }
  //   if (hex.length !== 6) {
  //     throw new Error('Invalid HEX color.');
  //   }
  //   // invert color components
  //   var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
  //     g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
  //     b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
  //   // pad each with zeros and return
  //   return '#' + Utility.padZero(r) + Utility.padZero(g) + Utility.padZero(b);
  // }

  static padZero(str: string) {
    let len = str.length || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }

}
